export const data = [
  {
    id: 1,
    name: "Idli",
    category: "breakfast",
    image: "idli.png",
    price: "₹ 35",
  },
  {
    id: 2,
    name: "Idli Vada",
    category: "breakfast",
    image: "idli-vada.png",
    price: "₹ 45",
  },
  {
    id: 3,
    name: "Poori Saagu",
    category: "breakfast",
    image: "poori.png",
    price: "₹ 45",
  },
  {
    id: 4,
    name: "Dosa ",
    category: "breakfast",
    image: "dosa.png",
    price: "₹ 40",
  },
  {
    id: 5,
    name: "Paddu",
    category: "breakfast",
    image: "paddu.png",
    price: "₹ 35",
  },
  {
    id: 6,
    name: "Paratha Varieties",
    category: "breakfast",
    image: "paratha.png",
    price: "₹ 50 - ₹ 80",
  },
  {
    id: 7,
    name: "South Indian Meals",
    category: "lunch",
    image: "south-meal.png",
    price: "₹ 60",
  },
  {
    id: 8,
    name: "Rice and Sambar",
    category: "lunch",
    image: "south-meal.png",
    price: "₹ 40",
  },
  {
    id: 9,
    name: "Chicken Biryani (Green)",
    category: "chicken",
    image: "biryani-green.png",
    price: "₹ 80",
  },
  {
    id: 10,
    name: "Chicken Biryani (Red)",
    category: "chicken",
    image: "biryani1.png",
    price: "₹ 80",
  },
  {
    id: 11,
    name: "Fish Curry",
    category: "fish",
    image: "fish-curry.png",
    price: "Seasonal",
  },
  {
    id: 12,
    name: "Fish Roast",
    category: "fish",
    image: "fish-fry.png",
    price: "Seasonal",
  },
  {
    id: 13,
    name: "Chicken Kabab",
    category: "chicken",
    image: "kabab.png",
    price: "₹ 60",
  },
];
